import React, { useState, useEffect, useContext } from 'react';
import clsx from 'clsx';
import { renderedData } from '../../organisms/SearchResults/searchResultsMainComponent';
import { MemberExclusiveBannerConstants } from '../../organisms/SearchResults/index.constant';
import { MemberExclusiveBannerProps } from '../../organisms/SearchResults/index.types';

import { StyledMemberExclusiveBanner } from './index.styles';
import { useGetBreakpoint, getClassForBreakpoint } from '@marriott/mi-ui-library-shop';

const MemberExclusiveBanner: React.FC<MemberExclusiveBannerProps> = ({ numberOfNights, pointsChecked }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { isMapViewEnabled, jsonContent }: any = useContext(renderedData);
  const [breakpoint, setBreakpoint] = useState<string | undefined>(useGetBreakpoint());
  let labelText = '';

  if (numberOfNights === MemberExclusiveBannerConstants.fourNights && pointsChecked) {
    labelText = jsonContent.labelForFourNights;
  } else if (numberOfNights >= MemberExclusiveBannerConstants.fiveNights && pointsChecked) {
    labelText = jsonContent.labelForFiveOrMoreNights;
  }

  // Reset breakpoint on window resize.
  useEffect(() => {
    function handleResize() {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      setBreakpoint(useGetBreakpoint());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <StyledMemberExclusiveBanner>
      <div className={'member-exclusive-banner ' + (isMapViewEnabled ? `map-view pr-3` : ``)}>
        <div className={clsx('container', 'banner-container', isMapViewEnabled ? `map-banner` : `list-banner`)}>
          <div className="col m-icon-text banner-section" tabIndex={0} role="banner">
            <span
              className={clsx(
                getClassForBreakpoint(breakpoint, 'icon-m', 'icon-s', 'icon-s'),
                'icon-inverse icon-extra-free-nights icon-holder'
              )}
            ></span>
            <div className="banner-label-container">
              <span
                className={clsx(
                  getClassForBreakpoint(
                    breakpoint,
                    't-subtitle-m',
                    't-subtitle-m',
                    isMapViewEnabled ? 't-label-alt-s' : 't-label-alt-xs'
                  ),
                  'banner-label'
                )}
              >
                {jsonContent.memberExclusiveLabel}
              </span>
              <span
                className={clsx(getClassForBreakpoint(breakpoint, 't-font-s', 't-font-s', 't-font-xs'), 'banner-text')}
              >
                {labelText}
              </span>
            </div>
          </div>
        </div>
      </div>
    </StyledMemberExclusiveBanner>
  );
};

export default MemberExclusiveBanner;
